import config from '../../../config';

import { HammerWebClientTypes, MyPortalTradeClientTypes, TennMobClientTypes, TennWebClientTypes } from './constants';

export const isTennMob = () => TennMobClientTypes.includes(config.auth.clientId);
export const isTennWeb = () => TennWebClientTypes.includes(config.auth.clientId);
export const isHammerWeb = () => HammerWebClientTypes.includes(config.auth.clientId);
export const isMyPortalTrade = () => MyPortalTradeClientTypes.includes(config.auth.clientId);
export const isHammerWebOrMyPortalTrade = () => isHammerWeb() || isMyPortalTrade();
